// 计算矩形左右边界和垂直线位置
// const xleft = 0.16261135688041312;
// const xright = 0.27387024311958685;

import { color } from "echarts";

// const trd_obs_mu = 0.2182408;
const xleft = 0.1732;
const xright = 0.229;
const trd_obs_mu = 0.2011;
    // 更新图表数据的函数
    function addSeries(data) {
        const combined_xy = data['df1'].map(item => [item.x1, item.y1]);
        const combined_x_low = data['df1'].map(item => [item.x1, item.ci_hec_low]);
        const combined_x_up =  data['df1'].map(item => [item.x1, item.ci_hec_up]);
        const trd_delta = data['gmst_df'].map(item => [item.gmst_trd, item.gmst_delta]);
        const y2_x2_2 = data['df2'].map(item => [item.x2_2, item.y2]);
        const y2_x2_1 = data['df2'].map(item => [item.x2_1, item.y2]);
        const yrs = data['yrs'];
        const model_name = data['model_name'];
        const gmst_ts_trans = data['gmst_ts_trans'];
        const colors = data['colors'];
        const hec_gmst_delta = data['hec_gmst_delta'];
        const y_max =data['y_max']

    
        var series1 = [];
        for (var i = 0; i < gmst_ts_trans.length; i++) {
        series1.push({
            xAxisIndex: 2,
            yAxisIndex: 2,
            name: model_name[i],
            type: 'line',
            data: transposeArray([yrs,gmst_ts_trans[i]]), // 使用索引 i 获取对应的数据
            // color: colors[i],
            color:'#c68642',  //不区分颜色 
            showSymbol: false,
            // tooltip:{},
            markLine: {
                data: [{name: model_name[i], yAxis:hec_gmst_delta[i]}],
                symbol: ['none'],
                silent: true ,// 设置为 true，禁用事件响应
                label: { show: false },
                lineStyle: {
                normal: {
                width: 1,
                color:'red',
                // color:'green',
                type: 'solid',
                }}
            }
            });
            }
          
        const markline_y = [];
        for (let i = 0; i < model_name.length; i++) {
            markline_y.push({
                name: model_name[i],
                yAxis: hec_gmst_delta[i]
            });
        };
    

        const series0=[
            {
                xAxisIndex: 0,
                yAxisIndex: 0,
                name: 'xf_hec',
                type: 'line',
                data: combined_xy,
                tooltip:{show:false},
                lineStyle:{color:'red',width:3},
                showSymbol: false,
                markArea: {
                        itemStyle: {
                        color: '#e4e4e4'},
                        label: {
                            show: true,
                            position: [100, 550],
                            formatter: '{b}',
                            rotate: 90,
                            fontWeight: 'normal',
                            fontSize: 20,
                            color: 'black'
                        },
                        silent: true ,// 设置为 true，禁用事件响应
                        data: [
                        [
                            {
                            name: 'Observation',
                            xAxis: xleft
                            },
                            {
                            xAxis: xright
                            }
                        ]]},             
                markLine: {
                    name : 'trd_obs_mu',                   
                    symbol: ['none'],
                    label: { show: false },
                    silent: true ,// 设置为 true，禁用事件响应
                    data: [{ xAxis: trd_obs_mu }],
                    lineStyle: {
                    normal: {
                    width: 2,
                    type: 'dashed',
                    color:'black'   //中轴线
                    // color: 'green'
                    }
                }     
                },            
            },
            {
                xAxisIndex: 0,
                yAxisIndex: 0,
                name: 'ci_hec_low',
                type: 'line',
                data: combined_x_low, 
                tooltip:{show:false},
                color: 'red',
                showSymbol: false,
                lineStyle: {
                    normal: {
                    width: 2,
                    type: 'dashed'
                    }
                }            
            },
            {
                xAxisIndex: 0,
                yAxisIndex: 0,
                name: 'ci_hec_up',
                type: 'line',
                data: combined_x_up,
                tooltip:{show:false},
                color: 'red',
                showSymbol: false,    
                lineStyle: {
                    normal: {
                    width: 2,
                    type: 'dashed'
                    }
                }    
            },
            {
                xAxisIndex: 0,
                yAxisIndex: 0,
                name: 'trd_delta',
                type: 'scatter',
                data: trd_delta,
                symbol:'circle',
                symbolSize :15,
                itemStyle: {
                    normal: {
                        color: "#f9f9f9fe",
                        borderColor: 'black',
                        borderWidth: 2,
                    }
                  },           
                tooltip: {
                    trigger: 'axis',
                    triggerOn :'click',
                    position: 'inside',
                    
                    show:true,
                    axisPointer:{
                        snap:true,}
                },               
        },
            {
                xAxisIndex: 1,
                yAxisIndex: 1,
                name: 'Unconstrained',
                type: 'line',
                data: y2_x2_1,
                silent: false,
                color: 'black',
                tooltip:{show:true},
                showSymbol: false,
            },
            {
                xAxisIndex: 1,
                yAxisIndex: 1,
                name: 'Constrained',
                type: 'line',
                data: y2_x2_2,
                tooltip:{show:true},
                silent: false,
                color: 'red',
                lineStyle:{ width:3},
                showSymbol: false,
                markLine: {
                silent: true ,// 设置为 true，禁用事件响应
                data: markline_y,
                symbol: ['none'],
                label: { show: false },
                lineStyle: {
                normal: {
                width: 1,
                color:'red',
                type: 'solid',
                }}
            }            
            },            
        ]
        
        return { series1: series1, series0: series0};
    }

    function transposeArray(array) {
        return array[0].map((_, colIndex) => array.map(row => row[colIndex]));
        }

export  {
    // 函数实现
    addSeries
}